import Navbar from "../../components/Navbar.js"
import Bottom from "../../components/Bottom.js"

import Probsol from "../../components/ProjectPageComponents/Probsol.js"
import Overview from "../../components/ProjectPageComponents/Overview.js"
import UnderConstruction from "../../components/ProjectPageComponents/UnderConstruction.js"


function DarkForestDesigns() {
  return (
    <>
      <Navbar />
      <div className="spacerM mnone"></div>
      <div style={{ height: '32px', width: '100%' }}></div>

      <Overview
        status="Personal Project"
        title="Dark Forest Designs"
        desc="Online shopping for custom handmade products"
        copyright=""
        links={["Live|https://dark-forest-designs.vercel.app/", "Github|https://github.com/AhmerAftabPatel/Dark_Forest_Designs"]}
        image="interface.png"
        style={{ backgroundColor: '#2A363B', borderRadius: '12px' }}
      />

      <div className="spacerM"></div>

      {/* <Probsol
        problem=""
        solution="WebRTC (Web Real-Time Communication) enables peer-to-peer audio, video, and data sharing between browsers without requiring plugins. Optionally implement RTCDataChannel for sending non-media data between peers. Our video calling application utilizes React for its frontend interface and leverages WebRTC for real-time communication capabilities. Users can initiate video calls directly from their web browsers, seamlessly accessing their camera and microphone through getUserMedia. A signaling server, powered by socket.io, facilitates peer discovery and session management, ensuring secure peer-to-peer connections via RTCPeerConnection. The application supports intuitive UI controls for managing calls, including mute options and call termination. With a focus on scalability and cross-browser compatibility, our solution enables reliable video communication experiences across diverse devices and operating systems, all within a secure HTTPS environment."
        tools="Reactjs, Typescript, webRTC, Firebase"
        team="Ahmer"
        duration="24h"
        optionname="Topic"
        optioncontent="webRTC"
      /> */}

      <div className="spacerL"></div>

      {/* <UnderConstruction/> */}

      <div className="spacerL"></div>
      <Bottom />
    </>
  );
}

export default DarkForestDesigns;
